/**
 * Created by ivan on 10.04.18.
 */

const ToolbarItem = function (type) {
    Object.assign(this, type);

    this.enabled = false;
    this.marked = false;

    this.onChangeStateListener = function () {};
    this.onShowForce = function () {};

    this.onFingerOnListener = function () {};
    this.onFingerOffListener = function () {};
    this.onGetView = function () {};
};

ToolbarItem.prototype.getText = function () {
};

ToolbarItem.prototype.getPrice = function () {
};

ToolbarItem.prototype.setFinger = function (finger, duration) {
    finger = !!finger;
    if (this.finger !== finger) {
        this.finger = finger;

        if (finger) {
            clearTimeout(this.fingerTimeout);
            this.onFingerOnListener();

            if (duration) {
                this.fingerTimeout = setTimeout(() => {
                    this.setFinger(false);
                }, duration);
            }
        } else {
            this.onFingerOffListener();
        }
    }
};

ToolbarItem.prototype.isVisible = function () {
    return this.enabled;
};

ToolbarItem.prototype.onClick = function () {
    this.unmark();
};

ToolbarItem.prototype.showForce = function () {
    this.onShowForce();
};

ToolbarItem.prototype.isAvailableOnScene = function () {
    return true;
};

ToolbarItem.prototype.enable = function () {
    if (this.enabled) {
        return;
    }

    this.enabled = true;
    this.onChangeStateListener();

    if (cleverapps.toolbar) {
        cleverapps.toolbar.updateItems();
    }
};

ToolbarItem.prototype.disable = function () {
    if (!this.enabled) {
        return;
    }

    this.unmark();
    this.enabled = false;
    this.onChangeStateListener();

    if (cleverapps.toolbar) {
        cleverapps.toolbar.updateItems();
    }
};

ToolbarItem.prototype.mark = function () {
    if (!this.marked) {
        this.marked = true;
        this.onChangeStateListener();
    }
};

ToolbarItem.prototype.unmark = function () {
    if (this.marked) {
        this.marked = false;
        this.onChangeStateListener();
    }
};

ToolbarItem.prototype.getForce = function () {
    return this.force;
};

ToolbarItem.prototype.getTargetTypes = function () {
    return this.targets;
};

ToolbarItem.prototype.onFollowPointer = function () {};

ToolbarItem.prototype.getIcon = function () {
    return (typeof this.icon === "function") ? this.icon() : this.icon;
};

ToolbarItem.FRIEND_REQUESTS = {
    type: 0,
    icon: bundles.toolbar.frames.toolbar_mail_icon_png
};

ToolbarItem.MINIGAME_BONUS = {
    type: 2,
    icon: bundles.toolbar.frames.toolbar_dailybonus_icon_png,
    grayscaleDisabled: true,
    force: Forces.MINIGAME_FORCE
};

ToolbarItem.LEADER_BOARD = {
    type: 3,
    icon: bundles.toolbar.frames.toolbar_leader_board_icon_png
};

ToolbarItem.WEEKLY_GOALS = {
    type: 5,
    icon: bundles.toolbar.frames.toolbar_weekly_goals_png
};

ToolbarItem.REWARDED_VIDEO = {
    type: 6,
    icon: bundles.toolbar.frames.toolbar_rewarded_video_icon_png
};

ToolbarItem.ORDERS = {
    type: 7,
    targets: "harvested",
    icon: bundles.toolbar.frames.toolbar_orders_icon_png
};

ToolbarItem.UNITS_LIBRARY = {
    type: 8,
    targets: "unitsLibrary",
    icon: function () {
        return cleverapps.skins.getSlot("toolbar_units_library_icon_png") || bundles.toolbar.frames.toolbar_units_library_icon_png;
    }
};

ToolbarItem.UNIT_SHOP = {
    type: 9,
    icon: bundles.toolbar.frames.toolbar_unit_shop_icon_png
};

ToolbarItem.TRAVEL_BOOK = {
    type: 10,
    icon: bundles.toolbar.frames.toolbar_travel_book_icon_png,
    force: Forces.TRAVEL_BOOK
};

ToolbarItem.CLANS = {
    type: 11,
    icon: bundles.toolbar.frames.toolbar_clans_icon_png,
    force: Forces.CLANS_ICON
};

ToolbarItem.ARMY_LIBRARY = {
    type: 12,
    targets: "armyLibrary",
    icon: bundles.toolbar.frames.toolbar_units_library_icon_png
};

ToolbarItem.MAGNET = {
    type: 13,
    icon: bundles.toolbar.jsons.unitmagnet_json,
    dragControls: ["toolbar", "MenuBarCoinsItem"]
};

ToolbarItem.STICKERS_BOOK = {
    type: 14,
    icon: bundles.toolbar.frames.toolbar_stickers_book_png,
    force: Forces.STICKERS_BOOK_FORCE,
    targets: ["stickersBook", "stickers", "joker"]
};

ToolbarItem.STICKERS_BOOK2 = {
    type: 17,
    icon: bundles.toolbar.frames.toolbar_stickers_book2_png,
    force: Forces.STICKERS_BOOK2_FORCE,
    targets: ["stickersBook2", "stickers2"]
};

ToolbarItem.LOCATIONS = {
    type: 15,
    icon: bundles.toolbar.frames.toolbar_locations_icon_png
};

ToolbarItem.DYNAMITE = {
    type: 16,
    icon: bundles.toolbar.jsons.dynamite_json,
    keepControls: true
};

ToolbarItem.FRIENDS_LIST_REQUESTS = {
    type: 18,
    icon: bundles.toolbar.frames.toolbar_friend_balloon_png
};

ToolbarItem.ACHIEVEMENTS = {
    type: 19,
    icon: bundles.toolbar.frames.toolbar_achievements_icon_png
};
